import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { useCallback, useEffect } from 'react';
var css = {
  "priceWidget": "oalp-3uqOL",
  "bgImage": "oalp-1DZVR",
  "container": "oalp-1C9IJ",
  "desktop": "oalp-9x0Yr",
  "usiStyle": "oalp-2zGEE",
  "priceContent": "oalp-1J_K5",
  "priceContent__priceRange": "oalp-1sgnG",
  "mobile": "oalp-1T9wo",
  "plBackground": "oalp-1B4cY",
  "cta": "oalp-3SMry",
  "carDetails": "oalp-2BtlU",
  "editIconWithText": "oalp-2kSlw",
  "editText": "oalp-1IE-4",
  "editIcon": "oalp-C2pkW",
  "carTitle": "oalp-2rnNY",
  "carSubtitle": "oalp-2j2mR",
  "mileage": "oalp-Yri_u",
  "newpriceWidget": "oalp-1qdOH",
  "carDetailsSection": "oalp-18za6",
  "carInfo": "oalp-34ANL",
  "carPriceSection": "oalp-3KwXV",
  "carPriceContent": "oalp-3ZVgM",
  "carSubText": "oalp-3Ch5C"
};
import { FormattedMessage as Translation } from 'react-intl';
import useValuationResult from "../BookAnAppointment/useValuationResults";
import ImageWrapper from "../../Components/ImageWrapper/ImageWrapper";
import { Icon, NewIconButton } from 'panamera-react-ui';
import { EVALUATION_STATES, EVALUATION_STATES_TRACKING } from "../../Constants/evaluation";
import classNames from 'classnames';
import DependencyManager from "../../DependencyManager";
import UserSession from "../../Utils/UserSession";
import { trackingHelper } from "../../Helpers/trackingHelper";
import { TRACKING_EVENTS } from "../../Constants/trackingEvents";
import { isEmpty } from "../../Helpers/bundle";
import LocalStorageHelper from "../../Utils/LocalStorageHelper";
import withConfig from "./../../ComponentDependency/withConfig";
export var PriceEstimation = function PriceEstimation(_ref) {
  var _classNames;
  var _ref$data = _ref.data,
    termsText = _ref$data.termsText,
    subText = _ref$data.subText,
    backgroundImage = _ref$data.backgroundImage,
    metadata = _ref.metadata,
    handleIconClick = _ref.handleIconClick,
    track = _ref.track,
    locationId = _ref.locationId,
    origin = _ref.origin,
    landingURLSearch = _ref.landingURLSearch,
    config = _ref.config,
    params = _ref.params;
  var _ref2 = metadata || {},
    style = _ref2.style,
    showEditIcon = _ref2.showEditIcon,
    _ref2$q2bFlow = _ref2.q2bFlow,
    q2bFlow = _ref2$q2bFlow === void 0 ? {} : _ref2$q2bFlow,
    usiFeature = _ref2.usiFeature,
    subTextStyle = _ref2.subTextStyle,
    showPolandBG = _ref2.showPolandBG;
  var PanameraConstants = DependencyManager.getDependency('constants');
  var _useValuationResult = useValuationResult(),
    maxPrice = _useValuationResult.maxPrice,
    minPrice = _useValuationResult.minPrice,
    displayName = _useValuationResult.displayName,
    displaySubName = _useValuationResult.displaySubName,
    displayMileage = _useValuationResult.displayMileage,
    predictedPrice = _useValuationResult.predictedPrice;
  useEffect(function () {
    trackingHelper({
      eventName: TRACKING_EVENTS.VALUATION_PAGE_OPEN,
      track: track,
      locationId: locationId,
      origin: origin,
      select_from: EVALUATION_STATES_TRACKING.VALUATION_COMPLETE,
      landingURLSearch: landingURLSearch,
      params: params,
      config: config.get()
    });
  }, []);
  var editIconClick = useCallback(function (e) {
    e.preventDefault();
    e.stopPropagation();
    UserSession.deleteLastSelectionOption();
    if (handleIconClick) {
      handleIconClick(EVALUATION_STATES.VALUATION_DONE);
      trackingHelper({
        eventName: TRACKING_EVENTS.VALUATION_EDIT_CAR_DETAILS,
        track: track,
        locationId: locationId,
        origin: origin,
        select_from: EVALUATION_STATES_TRACKING.VALUATION_COMPLETE,
        landingURLSearch: landingURLSearch,
        params: params,
        config: config.get()
      });
    }
  }, [handleIconClick, landingURLSearch, locationId, origin, track, config, params]);
  var getPrice = function getPrice() {
    if (usiFeature) {
      var priceObj = LocalStorageHelper.getItem('USI_PRICE');
      var usiPriceObj = priceObj && JSON.parse(priceObj);
      if (usiPriceObj === null || usiPriceObj === void 0 ? void 0 : usiPriceObj.price) {
        return /*#__PURE__*/React.createElement("div", {
          className: css.priceContent__priceRange,
          "data-aut-id": "est_price_val"
        }, (usiPriceObj === null || usiPriceObj === void 0 ? void 0 : usiPriceObj.price.max) === (usiPriceObj === null || usiPriceObj === void 0 ? void 0 : usiPriceObj.price.min) ? /*#__PURE__*/React.createElement("span", null, usiPriceObj === null || usiPriceObj === void 0 ? void 0 : usiPriceObj.price.currency.symbol, ' ', usiPriceObj === null || usiPriceObj === void 0 ? void 0 : usiPriceObj.price.predicted_price) : /*#__PURE__*/React.createElement("span", null, usiPriceObj === null || usiPriceObj === void 0 ? void 0 : usiPriceObj.price.currency.symbol, " ", usiPriceObj === null || usiPriceObj === void 0 ? void 0 : usiPriceObj.price.min, " -", ' ', usiPriceObj === null || usiPriceObj === void 0 ? void 0 : usiPriceObj.price.currency.symbol, " ", usiPriceObj === null || usiPriceObj === void 0 ? void 0 : usiPriceObj.price.max, ' ', /*#__PURE__*/React.createElement("sup", null, "*")));
      }
      return /*#__PURE__*/React.createElement("div", {
        className: css.priceContent__priceRange,
        "data-aut-id": "est_price_val"
      }, minPrice === maxPrice ? predictedPrice : "".concat(minPrice, " - ").concat(maxPrice), /*#__PURE__*/React.createElement("sup", null, "*"));
    }
    return /*#__PURE__*/React.createElement("div", {
      className: css.priceContent__priceRange,
      "data-aut-id": "est_price_val"
    }, minPrice === maxPrice ? predictedPrice : "".concat(minPrice, " - ").concat(maxPrice), /*#__PURE__*/React.createElement("sup", null, "*"));
  };
  if (!isEmpty(q2bFlow)) {
    return /*#__PURE__*/React.createElement("div", {
      className: css.newpriceWidget,
      style: style
    }, /*#__PURE__*/React.createElement("div", {
      className: css.carDetailsSection
    }, /*#__PURE__*/React.createElement("div", {
      className: css.carInfo
    }, /*#__PURE__*/React.createElement("p", null, q2bFlow === null || q2bFlow === void 0 ? void 0 : q2bFlow.prefix, " ", /*#__PURE__*/React.createElement("strong", null, displayName), " ", q2bFlow === null || q2bFlow === void 0 ? void 0 : q2bFlow.suffix)), showEditIcon && /*#__PURE__*/React.createElement("div", {
      "data-aut-id": "edit_btn"
    }, /*#__PURE__*/React.createElement(NewIconButton, {
      icon: "editSquare",
      size: 24,
      color: "blackText",
      onClick: editIconClick
    }))), /*#__PURE__*/React.createElement("div", {
      className: css.carPriceSection
    }, subText && /*#__PURE__*/React.createElement("p", {
      className: css.carSubText,
      style: subText.style
    }, subText.text), /*#__PURE__*/React.createElement("p", {
      className: css.carPriceContent,
      "data-aut-id": "est_price_val"
    }, minPrice === maxPrice ? predictedPrice : "".concat(minPrice, " - ").concat(maxPrice))), termsText && /*#__PURE__*/React.createElement("p", {
      className: css.termsText,
      style: termsText.style
    }, termsText.text));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: css.priceWidget,
    style: style
  }, backgroundImage && /*#__PURE__*/React.createElement(ImageWrapper, {
    image: backgroundImage,
    className: css.bgImage
  }), /*#__PURE__*/React.createElement("div", {
    className: classNames(css.container, (_classNames = {}, _defineProperty(_classNames, css[PanameraConstants.platform], true), _defineProperty(_classNames, css.usiStyle, usiFeature), _classNames)),
    style: subTextStyle
  }, !usiFeature && /*#__PURE__*/React.createElement("div", {
    className: css.carDetails
  }, showEditIcon && /*#__PURE__*/React.createElement("div", {
    className: css.editIconWithText
  }, /*#__PURE__*/React.createElement("span", {
    className: css.editText
  }, /*#__PURE__*/React.createElement(Translation, {
    id: "quoteAnotherCar"
  })), ' ', /*#__PURE__*/React.createElement("span", {
    className: css.editIcon,
    onClick: editIconClick,
    "data-aut-id": "edit_btn"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "editSquare",
    size: 24,
    color: "blackText"
  }))), /*#__PURE__*/React.createElement("div", {
    className: css.carTitle,
    "data-aut-id": "sel_brand"
  }, displayName), /*#__PURE__*/React.createElement("div", {
    className: css.carSubtitle,
    "data-aut-id": "sel_brand_title"
  }, displaySubName), displayMileage.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: css.mileage,
    "data-aut-id": "sel_brand_mileage"
  }, displayMileage, " ", /*#__PURE__*/React.createElement(Translation, {
    id: "mileage"
  }))), /*#__PURE__*/React.createElement("div", {
    className: classNames(css.priceContent, _defineProperty({}, css.plBackground, showPolandBG))
  }, subText && /*#__PURE__*/React.createElement("p", {
    className: css.subText,
    style: subText.style
  }, subText.text), getPrice()), termsText && /*#__PURE__*/React.createElement("p", {
    className: css.termsText,
    style: termsText.style
  }, termsText.text)));
};
export default withConfig(PriceEstimation);